import { jsx as r } from "react/jsx-runtime";
import d from "@mui/material/AccordionSummary";
import i from "styled-components";
import n from "../../../icons/chevron-down.js";
const s = {
  root: "summaryRoot",
  expanded: "summaryExpanded",
  disabled: "summaryDisabled",
  content: "summaryContent",
  expandIconWrapper: "summaryExpandIconWrapper"
}, t = i(d).withConfig({
  displayName: "StyledAccordionSummary"
})([
  "&&.summaryRoot{min-height:48px;font-size:",
  ";font-weight:",
  ";padding:0px 16px;}&&.summaryRoot.summaryExpanded{min-height:40px;}&&.summaryRoot.summaryExpanded{border-bottom:",
  ";}&& .summaryContent{padding:8px 0;margin:0px;}&&.summaryRoot .summaryExpandIconWrapper{padding:8px;transition:transform 0.25s linear;color:",
  ";svg{width:14px;height:14px;}}&&.summaryRoot.Mui-disabled{opacity:1;color:",
  ";}"
], ({ theme: o }) => o.typography.body500.fontSize, ({ theme: o }) => o.typography.fontWeightMedium, ({ theme: o, $divider: a }) => a ? `1px solid ${o.primaryBorder}` : "none", ({ theme: o }) => o.secondaryDisabled, ({ theme: o }) => o.isLightTheme ? o.secondaryDisabled : o.primaryDisabled), e = ({ children: o, divider: a = !1, ...m }) => /* @__PURE__ */ r(t, {
  expandIcon: /* @__PURE__ */ r(n, {}),
  ...m,
  classes: s,
  $divider: a,
  children: o
});
e.displayName = "AccordionSummary";
export {
  e as default
};
